import { BigNumber } from '@ethersproject/bignumber';
import { getLixiBagContract } from '../utils/getLixiBagContract';

export async function getGlobalWinningTicket(lixiBagAddress: string) {
  const contract = getLixiBagContract(lixiBagAddress);
  const ticketId = (await contract.getGlobalWinningTicket()) as BigNumber;
  return ticketId.toNumber();
}
